import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07097d84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "detail-content" }
const _hoisted_3 = { class: "detail-title" }
const _hoisted_4 = { class: "detail-date" }
const _hoisted_5 = { class: "detail-user" }
const _hoisted_6 = { style: {"margin-right":"20px"} }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-file" }, "附件:", -1))
const _hoisted_9 = { class: "files" }
const _hoisted_10 = ["src", "onClick"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, {
      right: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "delete-o",
          onClick: _ctx.fDelete
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.reqdata.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.reqdata.createDate), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, "发件人: " + _toDisplayString(_ctx.reqdata.createName), 1),
        _createElementVNode("div", null, "接收人: " + _toDisplayString(_ctx.reqdata.receiveName), 1)
      ]),
      _createElementVNode("div", {
        class: "detail-text",
        innerHTML: _ctx.reqdata.content
      }, null, 8, _hoisted_7),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reqdata.fileList, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            class: "file",
            src: item.url,
            key: index,
            onClick: ($event: any) => (_ctx.fShowFile(item))
          }, null, 8, _hoisted_10))
        }), 128))
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.popupShow) = $event)),
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "show-img",
          src: _ctx.imgFile
        }, null, 8, _hoisted_11)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}